<template>
    <div>
        <span>{{ item.name }}</span>
        <div class="hint">{{ $t('Contact ID #') + item.id }}</div>
    </div>
</template>

<script>
export default {
    name: "TheAutocompleteTemplate",
    props: {
        item: { required: true },
        searchText: { required: true }
    }
}
</script>